<script>
    import _ from 'lodash'
    import moment from 'moment'
    import OperationService from '@/request/aims/operation'
    import RecordService from '@/request/record/record'
    import OperatorService from '@/request/aims/operator'
    import anesthesiaModeService from '@/request/aims/anesthesiaMode'
    import SigningService from '@/request/aims/signingOperator'
    import DiagnosisService from '@/request/dictionary/diagnosis'
    import OperatingService from '@/request/dictionary/operating'
    import OrgUserService from '@/request/user/orguser'
    import OrgService from '@/request/user/org'
    import RoomService from '@/request/aims/room'
    import DeviceService from '@/request/aims/device'
    import DemandService from '@/request/aims/demand'
    import PostureService from '@/request/aims/posture'
    import AssistantService from '@/request/aims/assistant'
    import RuleService from '@/request/aims/rule'
    import PermissionUtils from '@/utils/permission'
    export default {
        name: 'AimsOperationEdit',
        props: {
            value: {
                type: Object,
                default () {
                    return {}
                }
            },
            showButtons: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                operationSaving: false,
                record: {},
                editOperation: {},
                defaultOperationValue: {
                    emergency: 0,
                    needWashNurse: 1,
                    needTourNurse: 1,
                    sdate: null,
                    startTime: null,
                    duration: 7200000,
                    operatorId: null,
                    first: null,
                    second: [],
                    diagnoses: [],
                    operatings: [],
                    anesthesias: null,
                    devices: [],
                    demands: [],
                    incisionType: null
                },
                hid: null,
                diagnoseLoading: false,
                diagnoseSelection: [],
                operationRule: {},
                demandSelection: [],
                roomSelection: [],
                deviceSelection: [],
                operatingLoading: false,
                operatingSelection: [],
                operatorSelection: [],
                signingSelection: [],
                orgUidList: [],
                doctorSelection: [],
                anesthesiaTypeSelection: [],
                dateSelection: {},
                visibleEditSigning: false
            }
        },
        computed: {},
        created: function () {
            this.init()
        },
        mounted: function () {},
        beforeDestroy () {},
        watch: {
            value () {
                this.init()
            },
            hid () {
                this.listRoom()
                this.listDemand()
                this.listAnesthesiaType()
                this.listDevice()
                this.listSigning()
                this.loadRule()
                this.listDoctor()
            },
            'editOperation.oid': function () {
                this.loadHospital()
                this.listOrgUser()
                this.listOperator()
            },
            'operationRule.time': function () {
                this.createDateSelection()
            },
            'editOperation.emergency': function (newVal, oldVal) {
                if (!_.isUndefined(oldVal) && oldVal !== null) {
                    this.$set(this.editOperation, 'sdate', null)
                    this.$set(this.editOperation, 'startTime', null)
                }
                this.createDateSelection()
                this.selectRoom()
            },
            'editOperation.sdate': function (val) {
                if (!val || _.isEmpty(this.dateSelection)) {
                    return
                }
                let cdate = this.editOperation.startTime ? moment(this.editOperation.startTime).startOf('day').valueOf() : null
                if (cdate && cdate === val) {
                    return
                }
                this.$set(this.editOperation, 'startTime', this.dateSelection[val][0].value)
            }
        },
        methods: {
            init () {
                this.editOperation = _.defaultsDeep({}, this.value, this.defaultOperationValue)
                let operatorStr = this.editOperation.operator
                if (operatorStr && operatorStr.indexOf('(') === 0) {
                    operatorStr = operatorStr.substring(1, operatorStr.length - 1)
                }
                if (operatorStr) {
                    this.$set(this.editOperation, 'operatorId', operatorStr + (this.editOperation.consultation ? '_1' : '_0'))
                }
                let firstStr = this.editOperation.assistantFirst
                if (firstStr && firstStr.indexOf('(') === 0) {
                    firstStr = firstStr.substring(1, firstStr.length - 1)
                }
                if (firstStr) {
                    this.$set(this.editOperation, 'first', _.parseInt(firstStr))
                }
                let secondStr = this.editOperation.assistantSecond
                if (secondStr && secondStr.indexOf('(') === 0) {
                    secondStr = secondStr.substring(1, secondStr.length - 1)
                }
                if (secondStr) {
                    this.$set(this.editOperation, 'second', _.map(_.split(secondStr, ')('), _.parseInt))
                }
                if (this.editOperation.diagnoseNames) {
                    this.$set(this.editOperation, 'diagnoses', _.split(this.editOperation.diagnoseNames, ','))
                }
                if (this.editOperation.operatingNames) {
                    this.$set(this.editOperation, 'operatings', _.split(this.editOperation.operatingNames, ','))
                }
                /* if (this.editOperation.anesthesiaType) {
                    this.$set(this.editOperation, 'anesthesias', _.split(this.editOperation.anesthesiaType, ','))
                } */
                if (this.editOperation.anesthesiaType) {
                    this.$set(this.editOperation, 'anesthesias', this.editOperation.anesthesiaType)
                }
                let deviceStr = this.editOperation.deviceIds
                if (deviceStr && deviceStr.indexOf('(') === 0) {
                    deviceStr = deviceStr.substring(1, deviceStr.length - 1)
                }
                if (deviceStr) {
                    this.$set(this.editOperation, 'devices', _.map(_.split(deviceStr, ')('), _.parseInt))
                }
                if (this.editOperation.roomDemand) {
                    this.$set(this.editOperation, 'demands', _.split(this.editOperation.roomDemand, ','))
                }
                this.createDateSelection()
                this.loadRecord()
            },
            createDateSelection () {
                const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
                let min = moment().add(1, 'd').startOf('day').valueOf()
                let max = moment().add(3, 'd').endOf('day').valueOf()
                let datemin = 8 * 60 * 60 * 1000
                let datemax = 20 * 60 * 60 * 1000
                let allowTime = this.operationRule.time || 18 * 60 * 60 * 1000
                if (this.editOperation.emergency) {
                    min = moment().add(1, 'h').startOf('hour').valueOf()
                    max = moment().add(1, 'd').endOf('day').valueOf()
                } else if (moment().valueOf() >= (moment().startOf('day') + allowTime)) {
                    min = moment().add(2, 'd').startOf('day').valueOf()
                }
                let ds = []
                let datetimes = {}
                let step = moment(max).diff(min, 'days') + 1
                for (let i = 0; i < step; i++) {
                    let start = moment(min).clone().add(i, 'days').startOf('day') + datemin
                    let end = moment(min).clone().add(i, 'days').startOf('day') + datemax
                    if (start < min) {
                        start  = min
                    }
                    let date = moment(start).startOf('day').valueOf()
                    let times = []
                    let cur = moment(start).valueOf()
                    while (cur <= end) {
                        times.push({
                            value: cur,
                            name: moment(cur).format('HH:mm') + (cur === end ? '以后' : '')
                        })
                        cur = moment(cur).clone().add(1, 'h').valueOf()
                    }
                    let alias = '今天'
                    let diff = moment(date).diff(moment().startOf('day'), 'days')
                    if (diff === 0) {
                        alias = '今天'
                    } else if (diff === 1) {
                        alias = '明天'
                    } else if (diff === 2) {
                        alias = '后天'
                    } else {
                        alias = weeks[moment(date).day()]
                    }
                    let item = {
                        value: date,
                        name: moment(date).format('MM月DD日') + '(' + alias + ')'
                    }
                    ds.push(item)
                    datetimes[date] = _.clone(times)
                }
                datetimes.dates = _.clone(ds)
                this.dateSelection = _.clone(datetimes)
                this.$nextTick(() => {
                    if (!this.editOperation.sdate && this.editOperation.startTime) {
                        this.$set(this.editOperation, 'sdate', moment(this.editOperation.startTime).startOf('day').valueOf())
                    }
                    if (!this.editOperation.sdate && !_.isEmpty(this.dateSelection)) {
                        this.$set(this.editOperation, 'sdate', this.dateSelection.dates[0].value)
                        this.$set(this.editOperation, 'startTime', this.dateSelection[this.editOperation.sdate][0].value)
                    }
                    if (this.editOperation.sdate < this.dateSelection.dates[0].value) {
                        this.$set(this.editOperation, 'sdate', this.dateSelection.dates[0].value)
                        this.$set(this.editOperation, 'startTime', this.dateSelection[this.editOperation.sdate][0].value)
                    }
                })
            },
            loadRecord () {
                let self = this
                if (!self.editOperation.drid) {
                    self.record = {}
                    return
                }
                RecordService.load({
                    id: self.editOperation.drid
                }).then(res => {
                    let data = res.result || {}
                    self.record = _.clone(data)
                    self.$set(self.editOperation, 'oid', self.record.oid)
                    if (_.isEmpty(self.editOperation.diagnoses) && self.record.diagnoseNames) {
                        self.$set(self.editOperation, 'diagnoses', _.split(self.record.diagnoseNames, ','))
                    }
                })
            },
            listOperating (query) {
                let self = this
                self.operatingLoading = true
                OperatingService.find({
                    pageOffset: 1,
                    pageSize: 100
                }, {
                    match: query || null
                }).then(res => {
                    let data = res.result['content'] || []
                    if (query) {
                        let evens = _.remove(data, item => {
                            return item.name === query
                        })
                        if (!_.isEmpty(evens)) {
                            data = _.concat(evens, data)
                        }
                    }
                    data = _.uniqBy(data, 'name')
                    self.operatingSelection = _.cloneDeep(data)
                    self.operatingLoading = false
                }, () => {
                    self.operatingSelection = []
                    self.operatingLoading = false
                })
            },
            listDiagnosis (query) {
                let self = this
                self.diagnoseLoading = true
                DiagnosisService.find({
                    pageOffset: 1,
                    pageSize: 100
                }, {
                    match: query || null
                }).then(res => {
                    let data = res.result['content'] || []
                    if (query) {
                        let evens = _.remove(data, item => {
                            return item.name === query
                        })
                        if (!_.isEmpty(evens)) {
                            data = _.concat(evens, data)
                        }
                    }
                    data = _.uniqBy(data, 'name')
                    self.diagnoseSelection = _.cloneDeep(data)
                    self.diagnoseLoading = false
                }, () => {
                    self.diagnoseSelection = []
                    self.diagnoseLoading = false
                })
            },
            loadHospital () {
                if (_.isEmpty(this.editOperation) || !this.editOperation.oid) {
                    this.hid = null
                    return
                }
                let self = this
                let phospital = OrgService.loadOrg({
                    descendantId: self.editOperation.oid,
                    parentTypeSn: 'lx0001001'
                })
                phospital.then(res => {
                    let hospital = _.cloneDeep(res.result || null)
                    if (!_.isEmpty(hospital)) {
                        self.hid = hospital.id
                    } else {
                        self.hid = null
                    }
                })
            },
            listOrgUser () {
                if (_.isEmpty(this.editOperation) || !this.editOperation.oid) {
                    this.hid = null
                    return
                }
                let self = this
                OrgUserService.listUid({
                    oids: self.editOperation.oid
                }).then(res => {
                    self.orgUidList = _.clone(res.result || [])
                })
            },
            loadRule () {
                if (!this.hid) {
                    this.operationRule = {}
                    return
                }
                RuleService.load({
                    hid: this.hid
                }).then(res => {
                    this.operationRule = _.clone(res.result || {})
                }).catch(() => {
                    this.operationRule = {}
                })
            },
            listRoom () {
                let self = this
                self.roomSelection = []
                if (!self.hid) {
                    return
                }
                RoomService.list({
                    hids: self.hid
                }).then(res => {
                    let data = res.result || []
                    self.roomSelection = _.sortBy(data, ['name'])
                    self.selectRoom()
                })
            },
            selectRoom () {
                let self = this
                if (self.editOperation.id && self.editOperation.room) {
                    return
                }
                if (_.isEmpty(self.roomSelection)) {
                    self.$set(self.editOperation, 'room', null)
                    return
                }
                if (!self.editOperation.emergency) {
                    self.$set(self.editOperation, 'room', self.roomSelection[_.random(self.roomSelection.length - 1)].id)
                } else {
                    self.$set(self.editOperation, 'room', null)
                }
            },
            listDemand () {
                let self = this
                self.demandSelection = []
                if (!self.hid) {
                    return
                }
                DemandService.list({
                    hids: self.hid
                }).then(res => {
                    let data = res.result || []
                    self.demandSelection = _.clone(data)
                })
            },
            listAnesthesiaType() {
                const defAnesthesiaType = [{
                    value: '全身麻醉',
                    label: '全身麻醉'
                }, {
                    value: '局部麻醉',
                    label: '局部麻醉'
                }, {
                    value: '椎管内阻滞麻醉',
                    label: '椎管内阻滞麻醉'
                }, {
                    value: '颈臂丛阻滞麻醉',
                    label: '颈臂丛阻滞麻醉'
                }];
                if (!this.hid) {
                    this.anesthesiaTypeSelection = defAnesthesiaType;
                    return;
                }
                anesthesiaModeService.list({
                    hid: this.hid
                }).then(res => {
                    if (_.isEmpty(res.result)) {
                        this.anesthesiaTypeSelection = defAnesthesiaType;
                    } else {
                        let data = [];
                        _.forEach(res.result, val => {
                            data.push({
                                value: val['anesthesiaType'],
                                label: val['anesthesiaType']
                            })
                        });
                        this.anesthesiaTypeSelection = data;
                    }
                })
            },
            listDevice () {
                let self = this
                self.deviceSelection = []
                if (!self.hid) {
                    return
                }
                DeviceService.list({
                    hids: self.hid
                }).then(res => {
                    let data = res.result || []
                    self.deviceSelection = _.clone(data)
                })
            },
            listOperator () {
                if (_.isEmpty(this.editOperation) || !this.editOperation.oid) {
                    this.operatorSelection = []
                    return
                }
                let self = this
                OperatorService.list({
                    oids: self.editOperation.oid
                }).then(res => {
                    let data = res.result ? res.result : []
                    _.forEach(data, operator => {
                        operator.value = operator.uid + '_0'
                    })
                    self.operatorSelection = _.clone(data)
                })
            },
            listSigning () {
                if (_.isEmpty(this.editOperation) || !this.hid) {
                    this.signingSelection = []
                    return
                }
                let self = this
                SigningService.list({
                    hids: self.hid
                }).then(res => {
                    let data = res.result ? res.result : []
                    _.forEach(data, operator => {
                        operator.value = operator.uid + '_1'
                    })
                    self.signingSelection = _.clone(data)
                })
            },
            listDoctor () {
                if (_.isEmpty(this.editOperation) || !this.editOperation.oid) {
                    this.doctorSelection = []
                    return
                }
                let self = this
                AssistantService.list({
                    hids: self.hid
                }).then(res => {
                    let data = res.result ? res.result : []
                    let ds = []
                    _.forEach(data, doctor => {
                        if (_.findIndex(ds, {'uid': doctor.uid}) >= 0) {
                            return
                        }
                        if (_.indexOf(self.orgUidList, doctor.uid) >= 0) {
                            ds.unshift(doctor)
                        } else {
                            ds.push(doctor)
                        }
                    })
                    self.doctorSelection = _.clone(ds)
                })
            },
            querySearchPosture (queryString, callback) {
                PostureService.list({
                    hid: this.hid
                }).then(res => {
                    let result = res.result || []
                    callback(result)
                })
            },
            handleCancelEditOperation () {
                this.editOperation = _.cloneDeep(this.defaultOperationValue)
                this.record = {}
                this.operationSaving = false
                this.$emit('close')
            },
            splitDiagnose (names) {
                var patt = new RegExp('([A-Za-z\\u4e00-\\u9fa5]|\\d(?=\\u578b)){1,}?([（\\(][^\\)）\\t\\n\\r\\f]{1,}[\\)）]|([A-Za-z0-9]{1,}[,;，；、/]{1}(?=[A-Za-z0-9])|[A-Za-z0-9]{1,}[_―/\\-]{1}[A-Za-z0-9]{1,}){1,}|[A-Za-z]{0,}[0-9]{1,}(?=[\\u4e00-\\u9fa5])|[A-Za-z°\\u4e00-\\u9fa5\\u2150-\\u218F]){0,}[\\u4e00-\\u9fa5A-Za-z]{0,}', 'g')
                let result = []
                var item = null
                while ((item = patt.exec(names)) != null) {
                    result.push(item[0])
                }
                return result
            },
            saveDiagnoses () {
                let self = this
                let promises = []
                let diagnosesIds = []
                let diagnoseNames = []
                let message = self.$message({
                    message: '正在保存诊断信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    if (_.isEmpty(self.editOperation.diagnoses)) {
                        self.$set(self.editOperation, 'diagnose', null)
                        self.$set(self.editOperation, 'diagnoseNames', null)
                        message.close()
                        reject(new Error('诊断不能为空'))
                        return
                    }
                    let tempDiagnose = self.splitDiagnose(self.editOperation.diagnoses)
                    if (_.join(tempDiagnose) === self.editOperation.diagnoseNames) {
                        message.close()
                        resolve()
                        return
                    }
                    if (!_.isEmpty(tempDiagnose)) {
                        _.forEach(tempDiagnose, value => {
                            if (_.isNumber(value)) {
                                diagnosesIds.push(value)
                            } else {
                                promises.push(DiagnosisService.save({
                                    hid: self.hospital ? self.hospital.id : null,
                                    name: value
                                }))
                            }
                        })
                    }
                    if (_.isEmpty(promises)) {
                        self.$set(self.editOperation, 'diagnose', _.join(diagnosesIds))
                        message.close()
                        resolve()
                        return
                    }
                    Promise.all(promises).then(values => {
                        if (_.isEmpty(values)) {
                            self.$set(self.editOperation, 'diagnose', _.join(diagnosesIds))
                            message.close()
                            resolve()
                            return
                        }
                        _.forEach(values, value => {
                            let data = value.result
                            if (!data) {
                                return
                            }
                            if (_.indexOf(diagnosesIds, data.id) < 0) {
                                diagnosesIds.push(data.id)
                                diagnoseNames.push(data.name)
                            }
                        })
                        self.$set(self.editOperation, 'diagnose', _.join(diagnosesIds))
                        self.$set(self.editOperation, 'diagnoseNames', _.join(diagnoseNames))
                        message.close()
                        resolve()
                    }, err => {
                        message.close()
                        reject(err)
                    })
                })
            },
            saveOperating () {
                let self = this
                let promises = []
                let operatingIds = []
                let message = self.$message({
                    message: '正在保存术式信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    if (_.isEmpty(self.editOperation.operatings)) {
                        self.$set(self.editOperation, 'operatingIds', null)
                        self.$set(self.editOperation, 'operatingNames', null)
                        message.close()
                        reject(new Error('术式不能为空'))
                        return
                    }
                    if (_.join(self.editOperation.operatings) === self.editOperation.operatingNames) {
                        message.close()
                        resolve()
                        return
                    }
                    if (!_.isEmpty(self.editOperation.operatings)) {
                        _.forEach(self.editOperation.operatings, value => {
                            if (_.isNumber(value)) {
                                operatingIds.push(value)
                            } else {
                                promises.push(OperatingService.save({
                                    hid: self.hid || null,
                                    name: value
                                }))
                            }
                        })
                    }
                    if (_.isEmpty(promises)) {
                        self.$set(self.editOperation, 'operatingIds', _.join(operatingIds))
                        message.close()
                        resolve()
                        return
                    }
                    Promise.all(promises).then(values => {
                        if (_.isEmpty(values)) {
                            self.$set(self.editOperation, 'operatingIds', _.join(operatingIds))
                            message.close()
                            resolve()
                            return
                        }
                        _.forEach(values, value => {
                            let data = value.result
                            if (!data) {
                                return
                            }
                            if (_.indexOf(operatingIds, data.id) < 0) {
                                operatingIds.push(data.id)
                            }
                        })
                        self.$set(self.editOperation, 'operatingIds', _.join(operatingIds))
                        message.close()
                        resolve()
                    }, err => {
                        message.close()
                        reject(err)
                    })
                })
            },
            saveOperation () {
                let self = this
                let message = this.$message({
                    message: '正在保存手术信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    // 判断修改的字段，如果这些字段没有修改表示病历没有被修改
                    let _operation = _.cloneDeep(self.editOperation)
                    _operation.pat = self.record.pat
                    let _operatorArr = _operation.operatorId ? _.split(_operation.operatorId, '_') : []
                    let _operator = _.toInteger(_operatorArr[0])
                    let _consultation = _.toInteger(_operatorArr[1])
                    _operation.operator = _operator
                    if (!_operation.operatorId) {
                        _operation.operatorName = null
                    }
                    _operation.consultation = _consultation
                    _operation.assistantFirst = _operation.first ? '(' + _operation.first + ')' : null
                    if (!_operation.first) {
                        _operation.assistantFirstName = null
                    }
                    _operation.assistantSecond = _.isEmpty(_operation.second) ? null : '(' + _.join(_operation.second, ')(') + ')'
                    if (_.isEmpty(_operation.second)) {
                        _operation.assistantSecondName = null
                    }
                    _operation.deviceIds = _.isEmpty(_operation.devices) ? null : '(' + _.join(_operation.devices, ')(') + ')'
                    // _operation.anesthesiaType = _operation.anesthesias ? _.join(_operation.anesthesias) : null
                    _operation.anesthesiaType = _operation.anesthesias || null
                    _operation.roomDemand = _operation.demands ? _.join(_operation.demands) : null
                    delete _operation.sdate
                    delete _operation.operatorId
                    delete _operation.first
                    delete _operation.diagnoses
                    delete _operation.operatings
                    delete _operation.anesthesias
                    delete _operation.devices
                    delete _operation.demands
                    delete _operation.second
                    if (!_operation.currentState || _operation.currentState < 2 || _operation.currentState > 5) {
                        _operation.currentState = 2
                    }
                    if (_.isEqual(_operation, self.value)) {
                        message.close()
                        resolve(self.value)
                        return
                    }
                    OperationService.save(_operation).then(res => {
                        let data = res.result || null
                        if (!data) {
                            message.close()
                            reject(new Error('保存手术失败'))
                            return
                        }
                        _.assign(self.editOperation, data)
                        message.close()
                        resolve(data)
                    }, err => {
                        message.close()
                        reject(err)
                    })
                })
            },
            submit () {
                let self = this
                self.$refs['editOperationForm'].validate(valid => {
                    if (valid) {
                        self.operationSaving = true
                        let promises = []
                        promises.push(self.saveDiagnoses())
                        promises.push(self.saveOperating())
                        Promise.all(promises).then(() => {
                            self.saveOperation().then(operation => {
                                self.$message({
                                    message: '保存手术成功',
                                    type: 'success'
                                })
                                this.$emit('input', operation)
                                this.$emit('saveDone', operation)
                            }, err => {
                                self.$message.error(err.message || err)
                                this.$emit('error', err)
                            }).finally(() => {
                                self.operationSaving = false
                            })
                        }).catch(err => {
                            self.$message.error(err.message || err)
                            self.operationSaving = false
                        })
                    } else {
                        self.$message.error('表单验证失败!')
                    }
                })
            },
            handleSaveDoneSigning () {
                this.listSigning()
            },
            saveSigning () {
                this.$refs.editSigningForm.save()
                this.visibleEditSigning = false
            },
            singleUpdatePerson (operation) {
                if (_.isEmpty(operation) || !operation.id) {
                    return false
                }
                if (!PermissionUtils.hasPermission('per_opration_001002', this.$store.getters.permissions, false)) {
                    return operation.currentState > 2
                } else {
                    return operation.currentState > 3
                }
            }
        }
    }
</script>

<template>
    <el-form ref="editOperationForm" label-position="right" label-width="100px" :model="editOperation" :disabled="operationSaving" size="small">
        <div class="record-info box">
            <el-row :gutter="20">
                <el-col :span="8">
                    <span>病历号：{{record.historySn}}</span>
                </el-col>
                <el-col :span="8">
                    <span v-if="record.hospitalized">床位号：{{record.bedid || '无'}}</span>
                </el-col>
                <el-col :span="8">
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <span>姓名：{{record.patName}}</span>
                </el-col>
                <el-col :span="8">
                    <span>性别：{{!!record.sex && record.sex === 2 ? '女' : '男'}}</span>
                </el-col>
                <el-col :span="8">
                    <span>年龄：{{record.age || '未知'}}岁</span>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <span>主治医生：{{record.attendingName || '无'}}</span>
                </el-col>
                <el-col :span="8">
                    <span>科室：{{record.orgName}}({{record.hname}})</span>
                </el-col>
                <el-col :span="8">
                    <span>诊断：{{record.diagnoseNames || '无'}}</span>
                </el-col>
            </el-row>
        </div>
        <el-row :gutter="20">
            <el-col :span="24">
                <div class="box">
                    <el-form-item label="诊断" prop="diagnoses" :rules="[{ required: true, message: '诊断不能为空', trigger: 'blur' }]">
                        <el-select
                                v-model="editOperation.diagnoses"
                                clearable
                                multiple
                                filterable
                                remote
                                allow-create
                                default-first-option
                                placeholder="输入关键词查找诊断(支持新建)"
                                :remote-method="listDiagnosis"
                                :loading="diagnoseLoading"
                                @focus="listDiagnosis()"
                                style="width: 100%;"
                                :disabled = "singleUpdatePerson(editOperation)">
                            <el-option
                                    v-for="item in diagnoseSelection"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <div class="box">
                    <el-form-item label="手术类型" prop="emergency">
                        <el-radio-group v-model="editOperation.emergency" :disabled = "singleUpdatePerson(editOperation)">
                            <el-radio :label="parseInt(0)" border>择期</el-radio>
                            <el-radio :label="parseInt(1)" border>急诊</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="意向时间" prop="sdate">
                        <el-row :gutter="0">
                            <el-col :span="11">
                                <el-form-item prop="sdate" style="margin: 0;">
                                    <el-select v-model="editOperation.sdate" clearable placeholder="请选择日期" style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                                        <el-option
                                                v-for="item in dateSelection.dates"
                                                :key="item.value"
                                                :label="item.name"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col style="text-align: center;" :span="2">-</el-col>
                            <el-col :span="11">
                                <el-form-item prop="date2" style="margin: 0;">
                                    <el-select v-model="editOperation.startTime" clearable placeholder="请选择时间" style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                                        <el-option
                                                v-for="item in dateSelection[editOperation.sdate]"
                                                :key="item.value"
                                                :label="item.name"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="预期时长" prop="duration">
                        <el-select v-model="editOperation.duration" clearable placeholder="请选择时长" style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                            <el-option :key="1800000" :label="'0.5小时'" :value="1800000"></el-option>
                            <el-option :key="3600000" :label="'1小时'" :value="3600000"></el-option>
                            <el-option :key="5400000" :label="'1.5小时'" :value="5400000"></el-option>
                            <el-option :key="7200000" :label="'2小时'" :value="7200000"></el-option>
                            <el-option :key="9000000" :label="'2.5小时'" :value="9000000"></el-option>
                            <el-option :key="10800000" :label="'3小时'" :value="10800000"></el-option>
                            <el-option :key="12600000" :label="'3.5小时'" :value="12600000"></el-option>
                            <el-option :key="14400000" :label="'4小时'" :value="14400000"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="术式" prop="operatings" :rules="[{ required: true, message: '术式不能为空', trigger: 'blur' }]">
                        <el-select
                                v-model="editOperation.operatings"
                                clearable
                                multiple
                                filterable
                                remote
                                allow-create
                                default-first-option
                                placeholder="输入关键词查找术式(支持新建)"
                                :remote-method="listOperating"
                                :loading="operatingLoading"
                                @focus="listOperating()"
                                style="width: 100%;"
                                :disabled = "singleUpdatePerson(editOperation)">
                            <el-option
                                    v-for="item in operatingSelection"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="切口类型" prop="incisionType">
                        <el-select v-model="editOperation.incisionType" placeholder="请选择切口类型" style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                            <!-- <el-option
                                    v-for="item in roomSelection"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option> -->
                            <el-option label="〇" value="〇"></el-option>
                            <el-option label="Ⅰ" value="Ⅰ"></el-option>
                            <el-option label="Ⅱ" value="Ⅱ"></el-option>
                            <el-option label="Ⅲ" value="Ⅲ"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="体位" prop="posture">
                        <el-autocomplete
                                v-model="editOperation.posture"
                                clearable
                                :fetch-suggestions="querySearchPosture"
                                value-key="name"
                                placeholder="输入体位"
                                style="width: 100%;"
                                :disabled = "singleUpdatePerson(editOperation)"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item v-if="!editOperation.emergency" label="手术间">
                        <el-row :gutter="0">
                            <el-col :span="12">
                                <el-form-item prop="room" style="margin: 0;">
                                    <el-select v-model="editOperation.room" placeholder="请选择意向手术间" style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                                        <el-option
                                                v-for="item in roomSelection"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="demands" style="margin: 0;">
                                    <el-select v-model="editOperation.demands" placeholder="请选择手术间要求" multiple style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                                        <el-option
                                                v-for="item in demandSelection"
                                                :key="item.id"
                                                :label="item.demand"
                                                :value="item.demand">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <!-- <el-form-item v-if="!editOperation.emergency" label="手术间" prop="room">
                        <el-select v-model="editOperation.room" placeholder="请选择意向手术间" style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                            <el-option
                                    v-for="item in roomSelection"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="!editOperation.emergency" label="手术间要求" prop="demands">
                        <el-select v-model="editOperation.demands" placeholder="请选择手术间要求" multiple style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                            <el-option
                                    v-for="item in demandSelection"
                                    :key="item.id"
                                    :label="item.demand"
                                    :value="item.demand">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                </div>
            </el-col>
            <el-col :span="12">
                <div class="box">
                    <el-form-item label="主刀医生" prop="operatorId" :rules="[{ required: true, message: '主刀不能为空', trigger: 'blur' }]">
                        <el-row :gutter="0">
                            <el-col :span="20">
                                <el-select v-model="editOperation.operatorId" placeholder="请选择主刀医生" style="width: 100%;">
                                    <el-option-group key="operator" label="科室主刀">
                                        <el-option
                                                v-for="item in operatorSelection"
                                                :key="item.value"
                                                :label="item.name"
                                                :value="item.value">
                                        </el-option>
                                    </el-option-group>
                                    <el-option-group key="signing" label="会诊主刀">
                                        <el-option
                                                v-for="item in signingSelection"
                                                :key="item.value"
                                                :label="item.name"
                                                :value="item.value">
                                        </el-option>
                                    </el-option-group>
                                </el-select>
                            </el-col>
                            <el-col :span="4">
                                <el-button icon="el-icon-circle-plus-outline" style="width: 100%;" @click="visibleEditSigning = true"></el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="一助" prop="first">
                        <el-select v-model="editOperation.first" filterable clearable placeholder="请选择一助" style="width: 100%;">
                            <el-option
                                    v-for="item in doctorSelection"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.uid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="二助" prop="second">
                        <el-select v-model="editOperation.second" filterable clearable placeholder="请选择二助" multiple style="width: 100%;">
                            <el-option
                                    v-for="item in doctorSelection"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.uid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="洗手护士" prop="needWashNurse">
                        <el-radio-group v-model="editOperation.needWashNurse" :disabled = "singleUpdatePerson(editOperation)">
                            <el-radio :label="parseInt(0)" border>不需要</el-radio>
                            <el-radio :label="parseInt(1)" border>需要</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="巡回护士" prop="needTourNurse">
                        <el-radio-group v-model="editOperation.needTourNurse" :disabled = "singleUpdatePerson(editOperation)">
                            <el-radio :label="parseInt(0)" border>不需要</el-radio>
                            <el-radio :label="parseInt(1)" border>需要</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="建议麻醉方式" prop="assistantSecond">
                        <el-select v-model="editOperation.anesthesias" clearable placeholder="请选择麻醉方式" style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                            <el-option
                                    v-for="item in anesthesiaTypeSelection"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备准备" prop="devices">
                        <el-select v-model="editOperation.devices" placeholder="请选择设备" multiple style="width: 100%;" :disabled = "singleUpdatePerson(editOperation)">
                            <el-option
                                    v-for="item in deviceSelection"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <div class="box">
                    <el-form-item label="材料准备" prop="specialPrepare">
                        <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="editOperation.specialPrepare" placeholder="请输入内固定材料或手术器械要求及其他特殊准备" :disabled = "singleUpdatePerson(editOperation)"></el-input>
                    </el-form-item>
                </div>
            </el-col>
        </el-row>
        <el-form-item v-if="showButtons">
            <el-button @click="handleCancelEditOperation">取消</el-button>
            <el-button type="primary" @click="submit()">确定</el-button>
        </el-form-item>
        <!-- 编辑主刀表单 -->
        <el-dialog title="添加会诊主刀" :visible.sync="visibleEditSigning" append-to-body :close-on-click-modal="false">
            <aims-signing-edit ref="editSigningForm" :hospital="hid" @save-done="handleSaveDoneSigning"></aims-signing-edit>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visibleEditSigning = false">取 消</el-button>
                <el-button type="primary" @click="saveSigning()">确 定</el-button>
            </div>
        </el-dialog>
    </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .box {
        padding: 20px 20px 0 20px;
        background: #F2F6FC;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        margin-bottom: 10px;
    }
    .box.record-info {
        padding: 20px;
        margin-bottom: 20px;
    }
</style>
